import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import SourceEditing from './sourceediting';

export default class Source extends Plugin {
  static get requires() {
    return [SourceEditing];
  }

  static get pluginName() {
    return 'Source';
  }
}